import { CompanyColumns } from '../dictionaries/columns-dictionary';
import { CatalogResponse } from '../models/catalog-response';
import { Column } from '../models/column';

/**
 * Configuration for columns to exclude from catalog responses by entity
 */
export interface ExcludedColumnConfig {
  [entity: string]: number[];
}

/**
 * Add entity-specific columns which you want to exclude from showing up in the search table column settings
 */
export const EXCLUDED_COLUMNS: ExcludedColumnConfig = {
  company: [CompanyColumns.CombinedCompanySearchFilter],
};

/**
 * Excludes columns from catalog based on entity-specific configuration
 * @param catalog - The catalog response
 * @param config - Configuration for columns to exclude by entity
 * @returns Modified catalog without the excluded columns
 */
export const excludeColumnsByEntity = <T extends Column = Column>(catalog: CatalogResponse<T>): CatalogResponse<T> => {
  return Object.entries(catalog).reduce((acc, [entity, sections]) => {
    const excludedIds = EXCLUDED_COLUMNS[entity] || [];

    if (excludedIds.length === 0) {
      acc[entity] = sections;
      return acc;
    }

    acc[entity] = sections.map(section => ({
      ...section,
      columns: section.columns.filter(col => !excludedIds.includes(col.columnId)),
    }));

    return acc;
  }, {} as CatalogResponse<T>);
};
